// ─────────────────────────────────────────────
// performanceTracker.ts
// Tracks slow API calls.
// Uses an injected logError callback instead of calling sendFrontendError
// directly — this ensures the infinite recursion guard in app.ts is respected.
// ─────────────────────────────────────────────

export const SLOW_API_THRESHOLD = 4500; // ms (3.5 seconds)

type LogErrorFn = (payload: {
    type: string;
    message: string;
    url?: string;
    method?: string;
    status?: number;
    context?: Record<string, unknown>;
}) => void;

// Injected at boot time from app.ts so we don't bypass logError()
let _logError: LogErrorFn | null = null;

export const initPerformanceTracker = (logError: LogErrorFn): void => {
    _logError = logError;
};

export const trackApiPerformance = (
    url: string | undefined,
    method: string | undefined,
    duration: number,
    status?: number
): void => {
    if (duration <= SLOW_API_THRESHOLD || !_logError) return;

    // Skip the error endpoint itself to prevent recursion
    if (url?.includes("/frontend-error")) return;

    _logError({
        type: "slow_api",
        message: `Slow API response: ${method?.toUpperCase()} ${url} took ${duration}ms`,
        url,
        method,
        status,
        context: {
            duration,
            threshold: SLOW_API_THRESHOLD,
            page: window.location.pathname,
            query: window.location.search,
        },
    });
};